import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import './webstoreLogin.scss';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import Button from '@mui/material/Button';
import HomeIcon from '@mui/icons-material/Home';
import { useNavigate, Link } from 'react-router-dom';
import { useWebstoreUser } from '../../context/webstoreUserContext';
import  Helmet from 'react-helmet';
const API_BASE_URL =
  process.env.NODE_ENV === 'production'
    ? process.env.REACT_APP_API_URL_PRODUCTION
    : process.env.REACT_APP_API_URL;

const WebstoreLogin = () => {
  const navigate = useNavigate();
  const { login } = useWebstoreUser();

  const [isLogin, setIsLogin] = useState(true);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const [formData, setFormData] = useState({
    username: '',
    password: '',
    confirmPassword: '',
    email: '',
    emailOrUsername: '',
    name: '',
    address: '',
    contactNumber: '',
  });

  const handleChange = (e) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!isLogin && formData.password !== formData.confirmPassword) {
      toast.error("Passwords don't match");
      return;
    }

    const endpoint = isLogin
      ? `${API_BASE_URL}/api/webstore-users/login`
      : `${API_BASE_URL}/api/webstore-users/register`;

    try {
      const payload = isLogin
        ? { emailOrUsername: formData.emailOrUsername, password: formData.password }
        : formData;

      const res = await axios.post(endpoint, payload);

      if (isLogin) {
        if (res.data.token && res.data.user) {
          localStorage.setItem('token', res.data.token);
          login(res.data.user); // ✅ Store full user (with _id) to context and localStorage
          toast.success('Login successful!');
          navigate('/webstore');
        } else {
          toast.error('Invalid response from server');
        }
      } else {
        toast.success('Registration successful! Please log in.');
        setIsLogin(true);
      }
    } catch (err) {
      console.error('Registration/Login Error:', err.response || err);
      const msg = err.response?.data?.message || 'Something went wrong';
      toast.error(msg);
    }
  };

  return (
    <div className="webstore-login-wrapper">
      <Helmet>
        <title>Webstore | Login</title>
        <meta name="description" content="Webstore | Login" />
        <meta property="og:title" content="Webstore | Login" />
      </Helmet>
      <div className="login-container">
        <div className="form-toggle">
          <button
            onClick={() => setIsLogin(true)}
            className={isLogin ? 'active' : ''}
          >
            Login
          </button>
          <button
            onClick={() => setIsLogin(false)}
            className={!isLogin ? 'active' : ''}
          >
            Register
          </button>
        </div>

        <form onSubmit={handleSubmit} className="login-form">
          {!isLogin && (
            <>
              <label htmlFor="username" className="field-label">Username</label>
              <input
                id="username"
                type="text"
                name="username"
                placeholder="Username"
                value={formData.username}
                onChange={handleChange}
                required
              />

              <label htmlFor="email" className="field-label">Email</label>
              <input
                id="email"
                type="email"
                name="email"
                placeholder="Email"
                value={formData.email}
                onChange={handleChange}
                required
              />

              <label htmlFor="name" className="field-label">Full Name</label>
              <input
                id="name"
                type="text"
                name="name"
                placeholder="Full Name"
                value={formData.name}
                onChange={handleChange}
                required
              />

              <label htmlFor="address" className="field-label">Address</label>
              <input
                id="address"
                type="text"
                name="address"
                placeholder="Address"
                value={formData.address}
                onChange={handleChange}
                required
              />

              <label htmlFor="contactNumber" className="field-label">Contact Number</label>
              <input
                id="contactNumber"
                type="text"
                name="contactNumber"
                placeholder="Contact Number"
                value={formData.contactNumber}
                onChange={handleChange}
                required
              />
            </>
          )}

          {isLogin && (
            <>
              <label htmlFor="emailOrUsername" className="field-label">Email or Username</label>
              <input
                id="emailOrUsername"
                type="text"
                name="emailOrUsername"
                placeholder="Email or Username"
                value={formData.emailOrUsername}
                onChange={handleChange}
                required
              />
            </>
          )}

          <label htmlFor="password" className="field-label">Password</label>
          <div className="password-field">
            <input
              id="password"
              type={showPassword ? 'text' : 'password'}
              name="password"
              placeholder="Password"
              value={formData.password}
              onChange={handleChange}
              required
            />
            <span className="toggle-icon" onClick={() => setShowPassword(prev => !prev)}>
              {showPassword ? <VisibilityOff /> : <Visibility />}
            </span>
          </div>

          {!isLogin && (
            <>
              <label htmlFor="confirmPassword" className="field-label">Confirm Password</label>
              <div className="password-field">
                <input
                  id="confirmPassword"
                  type={showConfirm ? 'text' : 'password'}
                  name="confirmPassword"
                  placeholder="Confirm Password"
                  value={formData.confirmPassword}
                  onChange={handleChange}
                  required
                />
                <span className="toggle-icon" onClick={() => setShowConfirm(prev => !prev)}>
                  {showConfirm ? <VisibilityOff /> : <Visibility />}
                </span>
              </div>
            </>
          )}

          <button type="submit">{isLogin ? 'Login' : 'Register'}</button>

          <Link to='/webstore' className="login-home-button">
            <HomeIcon />
          </Link>
        </form>
      </div>
    </div>
  );
};

export default WebstoreLogin;
